import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { QuickTestimonials } from './components/QuickTestimonials';
import { FacebookPixel } from './components/FacebookPixel';
// Lazy-load below-the-fold sections to shrink the initial JS bundle
const Pain = lazy(() => import('./components/Pain').then(m => ({
  default: m.Pain
})));
const BreakPhrase = lazy(() => import('./components/BreakPhrase').then(m => ({
  default: m.BreakPhrase
})));
const Product = lazy(() => import('./components/Product').then(m => ({
  default: m.Product
})));
const Tomos = lazy(() => import('./components/Tomos').then(m => ({
  default: m.Tomos
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const EliteUpsell = lazy(() => import('./components/EliteUpsell').then(m => ({
  default: m.EliteUpsell
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
const SectionFallback = () => <div className="py-16 flex justify-center items-center" data-id="element-0">
    <div className="w-8 h-8 border-2 border-gray-300 border-t-[#C76F4A] rounded-full animate-spin" data-id="element-1"></div>
  </div>;
export function App() {
  return <div className="min-h-screen bg-[#FAF7F2] font-sans text-[#1A1A1A] selection:bg-brand-green selection:text-white" data-id="element-2">
      <FacebookPixel data-id="element-3" />
      <Hero data-id="element-4" />
      <SocialProof data-id="element-5" />
      <QuickTestimonials data-id="element-6" />
      <Suspense fallback={<SectionFallback data-id="element-8" />} data-id="element-7">
        <Pain data-id="element-9" />
        <BreakPhrase data-id="element-10" />
        <Product data-id="element-11" />
        <Tomos data-id="element-12" />
        <Bonuses data-id="element-13" />
        <Pricing data-id="element-14" />
        <EliteUpsell data-id="element-15" />
        <ComparisonTable data-id="element-16" />
        <Testimonials data-id="element-17" />
        <Guarantee data-id="element-18" />
        <FAQ data-id="element-19" />
        <FinalCTA data-id="element-20" />
        <SocialProofPopup data-id="element-21" />
      </Suspense>
    </div>;
}